module.exports = __webpack_public_path__ + "img/00003.ecad54d3.webp";